import React from "react"
import {Link} from "gatsby"
import styled from "styled-components"

import {rhythm, scale} from "../utils/typography"

class Layout extends React.Component {
  render() {
    const {location, title, children} = this.props;
    const rootPath = `${__PATH_PREFIX__}/`;
    const blogPath = `${__PATH_PREFIX__}/blog/`;
    let header;

    if (location.pathname === rootPath || location.pathname === blogPath) {
      header = (
        <h1
          style={{
            ...scale(1.4),
            fontFamily: `medium-content-title-font, Georgia, Cambria, "Times New Roman", Times, serif`,
            marginBottom: 30,
            marginTop: 0,
            textAlign: 'center',
            fontWeight: 400,
                          color: "#4C6F97",


          }}
        >
          <Link
            style={{
              boxShadow: `none`,
              textDecoration: `none`,
              color: `inherit`,
            }}
            to={location.pathname === blogPath ? `/` : `/blog/`}
          >
            {title}
          </Link>
        </h1>
      )
    } else {
      header = (
        <h1
          style={{
            fontFamily: `medium-content-title-font, Georgia, Cambria, "Times New Roman", Times, serif`,
            marginTop: 0,
            marginBottom: 0,
            fontWeight: 400,

          }}
        >
          <Link
            style={{
              boxShadow: `none`,
              textDecoration: `none`,
              color: "#4C6F97",
            }}
            to={`/blog/`}
          >
            {title}
          </Link>
        </h1>
      )
    }
    return (
      <Wrapper>
        <div
          style={{
            marginLeft: `auto`,
            marginRight: `auto`,
            maxWidth: rhythm(24),
            padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
          }}
        >
          <header>{header}</header>
          <main>{children}</main>
        </div>
        <Footer>
          © {new Date().getFullYear()}, Built with
          {` `}
          <a href="https://www.oxfordlearnersdictionaries.com/us/definition/american_english/care_2">Care</a>
        </Footer>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  min-height: 100vh;
`;

const Footer = styled.footer`
  text-align: center;
  margin: 24px;
`;

export default Layout
